"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkQualitySignalText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../../context/room_session");
const rxjs_1 = require("../../../../hooks/rxjs");
const NetworkQualitySignalText = () => {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [remoteNetworkQuality] = (0, rxjs_1.useObservable)(roomSession.media.remoteNetworkQuality);
    return ((0, jsx_runtime_1.jsx)(NetworkSignalLevelTextContainer, { children: (remoteNetworkQuality !== null || remoteNetworkQuality !== undefined) && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "p", color: "grey60", semibold: true, size: "medium", style: { marginLeft: '12px', lineHeight: '21px', marginBottom: '6px' } }, { children: "Customer Network Strength" })) })) }));
};
exports.NetworkQualitySignalText = NetworkQualitySignalText;
const NetworkSignalLevelTextContainer = (0, ui_react_1.styled)(ui_react_1.Column)();
//# sourceMappingURL=network_quality_text.js.map